//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'AIHSDC',
  data () {
    return {
      form: {
        ana_sma: '',
        lkm1: '0',
        sla: '0',
        igg: '',
        liver: '',
        hepatitis: '0',
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '1', name: '≥1:40'},
        {value: '2', name: '≥1:80'}
      ],
      dataList2: [
        {value: '1', name: '＞正常值上限'},
        {value: '2', name: '≥1.1倍正常值上限'}
      ],
      dataList3: [
        {value: '1', name: '符合AIH'},
        {value: '2', name: '典型AIH表现'}
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        let antibody = form.ana_sma + form.lkm1 * 2 + form.sla * 2
        if (antibody >= 2) {
          antibody = 2
        }
        let result = antibody + form.igg + form.liver + form.hepatitis * 2
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/RI/AIHSDC.vue